type LoaderParamsT = {
  src: string;
  width: number;
  height: number;
  quality?: number;
  format: string;
};

export const createCloudfrontLoader =
  (baseURL: string) =>
  ({ src, width, height, quality = 75, format = "auto" }: LoaderParamsT) => {
    if (src.startsWith("http")) return src;

    const url = new URL(`${baseURL}${src}`);

    if (format) url.searchParams.set("format", format);
    url.searchParams.set("width", width?.toString() ?? "auto");
    url.searchParams.set("height", height?.toString() ?? "auto");
    if (quality) url.searchParams.set("quality", quality.toString());
    url.searchParams.set("fit", "contain");

    return url.href;
  };
